import { createContext, useContext, useState, useMemo } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "pt";
    return localStorage.getItem("vad_lang") || "pt";
  });

  const toggle = () => {
    const next = lang === "pt" ? "en" : "pt";
    setLang(next);
    try { localStorage.setItem("vad_lang", next); } catch {}
  };

  const value = useMemo(() => ({ lang, setLang, toggle, t: translations[lang] }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
